<cdk-virtual-scroll-viewport itemSize="75" class="expert-list-viewport" data-test-id="opportunity-expert-list-table">
  <div class="mx-4">
    <app-expert
      *cdkVirtualFor="let expert of experts; trackBy: trackByFn; let i = index"
      class="example-item"
      [client]="client"
      [opportunity]="opportunity"
      [expert]="expert"
      [openFilter]="openFilter"
      [index]="i"
      [showAffiliations]="showAffiliations"
      (selectExpertSignal)="emitSelectExpertSignal($event)"
      (toggleAdminRejectStatusSignal)="emitToggleAdminRejectStatusSignal($event)"
      (navigateToExpertSignal)="emitNavigateToExpertSignal($event)"
      (showExpertScreenerSignal)="emitShowScreenerResults(expert)"
      (addExpertiseToSearchSignal)="emitAddExpertiseToSearchSignal($event)"
    >
    </app-expert>
  </div>
</cdk-virtual-scroll-viewport>

@if (experts.length && experts.length > 10) {
  <mat-icon class="go-to-top" title="Go to top" (click)="goToTop()"> keyboard_capslock </mat-icon>
}
